import { render, staticRenderFns } from "./BaseTaskStatus.vue?vue&type=template&id=21fbb882&"
import script from "./BaseTaskStatus.vue?vue&type=script&lang=js&"
export * from "./BaseTaskStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports